var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isButtonDisplayed)?_c('div',{staticClass:"scroll-top"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":_vm.scrollToTop}},[_c('span',{staticClass:"log-icon-chevron-up"})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }